"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumTypeSwitchWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var PremiumTypeSwitchWidget = /** @class */ (function (_super) {
    __extends(PremiumTypeSwitchWidget, _super);
    function PremiumTypeSwitchWidget(props) {
        return _super.call(this, props) || this;
    }
    PremiumTypeSwitchWidget.prototype.render = function () {
        var _this = this;
        var annualSelected = this.props.interaction.factors.premiumType === "annual";
        var isNotFreeInsurance = this.props.interaction.factors.amountToPay > 0;
        return isNotFreeInsurance && ((0, jsx_runtime_1.jsxs)("div", { className: "premium-type-switch", children: [(0, jsx_runtime_1.jsx)("div", { className: "btn-text annual-btn", onKeyDown: function () { return _this.switchPremiumType(); }, onClick: function () { return _this.switchPremiumType(); }, children: (0, jsx_runtime_1.jsx)("span", { children: "Pay annually" }) }), (0, jsx_runtime_1.jsx)("div", { className: "cursor-pointer", children: (0, jsx_runtime_1.jsx)("div", { className: annualSelected ? "tier-premium-type-input annual" : "tier-premium-type-input monthly", onKeyDown: function () { return _this.switchPremiumType(); }, onClick: function () { return _this.switchPremiumType(); }, children: (0, jsx_runtime_1.jsx)("span", {}) }) }), (0, jsx_runtime_1.jsx)("div", { className: "btn-text monthly-btn", onKeyDown: function () { return _this.switchPremiumType(); }, onClick: function () { return _this.switchPremiumType(); }, children: (0, jsx_runtime_1.jsx)("span", { children: "Pay monthly" }) })] }));
    };
    PremiumTypeSwitchWidget.prototype.switchPremiumType = function () {
        var newPremiumType = this.props.interaction.factors.premiumType === "annual" ? "monthly" : "annual";
        this.props.executePremiumChange(newPremiumType);
    };
    return PremiumTypeSwitchWidget;
}(React.Component));
exports.PremiumTypeSwitchWidget = PremiumTypeSwitchWidget;
//# sourceMappingURL=PremiumTypeSwitchWidget.js.map